import { render } from "./SubmissionListItem.vue?vue&type=template&id=33bf7e16&scoped=true"
import script from "./SubmissionListItem.vue?vue&type=script&lang=js"
export * from "./SubmissionListItem.vue?vue&type=script&lang=js"

import "./SubmissionListItem.vue?vue&type=style&index=0&id=33bf7e16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bf7e16"]])

export default __exports__